import { Injectable } from '@angular/core';
import { ApiService } from '../api-service/api.service';
import { CustomerInterface } from '@monsido/ng2/modules/models/api/interfaces/customer.interface';
import { Customer } from '@monsido/ng2/modules/models/api/customer';

@Injectable({
    providedIn: 'root',
})
export class AccountRepoService {

    constructor (private apiService: ApiService) { }

    get (): Promise<Customer> {
        return this.apiService.get<CustomerInterface>('account').then((model: CustomerInterface) => this.toModel(model));
    }

    update (data: CustomerInterface): Promise<Customer> {
        return this.apiService.patch<CustomerInterface>('account', data).then((model: CustomerInterface) => this.toModel(model));
    }

    toModel (model: CustomerInterface): Customer {
        return new Customer(model);
    }
}
